// FETCH ALL PARTY MASTER
export const FETCH_PARTY_MASTER_REQUEST = 'FETCH_PARTY_MASTER_REQUEST';
export const FETCH_PARTY_MASTER_SUCCESS = 'FETCH_PARTY_MASTER_SUCCESS';
export const FETCH_PARTY_MASTER_FAILURE = 'FETCH_PARTY_MASTER_FAILURE';

export const FETCH_PARTY_MASTER_PAN_FILE_REQUEST = 'FETCH_PARTY_MASTER_PAN_FILE_REQUEST';
export const FETCH_PARTY_MASTER_PAN_FILE_SUCCESS = 'FETCH_PARTY_MASTER_PAN_FILE_SUCCESS';
export const FETCH_PARTY_MASTER_PAN_FILE_FAILURE = 'FETCH_PARTY_MASTER_PAN_FILE_FAILURE';

export const FETCH_PARTY_MASTER_GST_FILE_REQUEST = 'FETCH_PARTY_MASTER_GST_FILE_REQUEST';
export const FETCH_PARTY_MASTER_GST_FILE_SUCCESS = 'FETCH_PARTY_MASTER_GST_FILE_SUCCESS';
export const FETCH_PARTY_MASTER_GST_FILE_FAILURE = 'FETCH_PARTY_MASTER_GST_FILE_FAILURE';

// CREATE PARTY MASTER
export const CREATE_PARTY_MASTER_REQUEST = 'CREATE_PARTY_MASTER_REQUEST';
export const CREATE_PARTY_MASTER_SUCCESS = 'CREATE_PARTY_MASTER_SUCCESS';
export const CREATE_PARTY_MASTER_FAILURE = 'CREATE_PARTY_MASTER_FAILURE';

// UPDATE PARTY MASTER
export const UPDATE_PARTY_MASTER_REQUEST = 'UPDATE_PARTY_MASTER_REQUEST';
export const UPDATE_PARTY_MASTER_SUCCESS = 'UPDATE_PARTY_MASTER_SUCCESS';
export const UPDATE_PARTY_MASTER_FAILURE = 'UPDATE_PARTY_MASTER_FAILURE';

// FETCH SINGLE STATE OF PARTY MASTER
export const FETCH_SINGLE_PARTY_MASTER_REQUEST = 'FETCH_SINGLE_PARTY_MASTER_REQUEST';
export const FETCH_SINGLE_PARTY_MASTER_SUCCESS = 'FETCH_SINGLE_PARTY_MASTER_SUCCESS';
export const FETCH_SINGLE_PARTY_MASTER_FAILURE = 'FETCH_SINGLE_PARTY_MASTER_FAILURE';

// DELETE PARTY MASTER
export const DELETE_PARTY_MASTER_REQUEST = 'DELETE_PARTY_MASTER_REQUEST';
export const DELETE_PARTY_MASTER_SUCCESS = 'DELETE_PARTY_MASTER_SUCCESS';
export const DELETE_PARTY_MASTER_FAILURE = 'DELETE_PARTY_MASTER_FAILURE';

// FETCH PROPERTY
export const FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_REQUEST = 'FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_REQUEST';
export const FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_SUCCESS = 'FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_SUCCESS';
export const FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_FAILURE = 'FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_FAILURE';

// FETCH BANK NAME
export const FETCH_BANK_NAME_REQUEST = 'FETCH_BANK_NAME_REQUEST';
export const FETCH_BANK_NAME_SUCCESS = 'FETCH_BANK_NAME_SUCCESS';
export const FETCH_BANK_NAME_FAILURE = 'FETCH_BANK_NAME_FAILURE';

export const RESET_PARTY_MASTER_INFO = 'RESET_PARTY_MASTER_INFO';

export const CREATE_PARTY_MASTER_FORM = 'CREATE_PARTY_MASTER_FORM';

export const UPDATE_PARTY_MASTER_FORM = 'UPDATE_PARTY_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_PARTY_DETAILS = 'NAVIGATE_PARTY_DETAILS';

// NAVIGATE TO PARTY MASTER COMPONENT
export const NAVIGATE_PARTY_MASTER = 'NAVIGATE_PARTY_MASTER';

export const SET_XLSX_DATA_OF_PARTY_MASTER = 'SET_XLSX_DATA_OF_PARTY_MASTER';

export const SET_ACTIVE_KEY_PARTY_MASTER = 'SET_ACTIVE_KEY_PARTY_MASTER';

export const SET_PAN_FILE_NAME_PARTY_MASTER = 'SET_PAN_FILE_NAME_MASTER';

export const SET_GST_FILE_NAME_PARTY_MASTER = 'SET_GST_FILE_NAME_MASTER';


export const PARTY_MASTER_SET_ACTIVE_REQUEST = 'PARTY_MASTER_SET_ACTIVE_REQUEST';
export const PARTY_MASTER_SET_ACTIVE_SUCCESS = 'PARTY_MASTER_SET_ACTIVE_SUCCESS';
export const PARTY_MASTER_SET_ACTIVE_FAILURE = 'PARTY_MASTER_SET_ACTIVE_FAILURE';
